export const isDataError = ( lastError : Record<string, unknown> ): boolean => {
    return (lastError && Object.keys(lastError)?.length > 0) as boolean  ?? false;
};